import { render, staticRenderFns } from "./Follower.vue?vue&type=template&id=0f781328&lang=pug"
import script from "./Follower.vue?vue&type=script&lang=js"
export * from "./Follower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports